import { useTranslation } from 'react-i18next'

const BADGE_CLASS = 'status-badge'

export default function OrderStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation()
  const label = t([`orderStatus.${status}`, 'orderStatus.unknown'])
  return <span className={`${BADGE_CLASS} status-badge--order`}>{label}</span>
}